__turbopack_context__.v({
  "ratingBubble": "jK1vVa_ratingBubble",
  "wrapper": "jK1vVa_wrapper",
});
